import { render, staticRenderFns } from "./SkillAmountsCpt.vue?vue&type=template&id=d1df1484&scoped=true&"
import script from "./SkillAmountsCpt.vue?vue&type=script&lang=ts&"
export * from "./SkillAmountsCpt.vue?vue&type=script&lang=ts&"
import style0 from "./SkillAmountsCpt.vue?vue&type=style&index=0&id=d1df1484&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1df1484",
  null
  
)

export default component.exports